import axios from 'axios';
import { useContext, useRef } from "react";
import { Context } from "./Reducers/Store";
import { useTokenHelper } from './Hooks/useTokenHelper';

export const WithAxios = ({ children }) => {
    const [, dispatch] = useContext(Context);
    const requests = useRef(0);
    const tokenHelper = useTokenHelper();

    if (global._interceptor1 != null) axios.interceptors.request.eject(global._interceptor1);
    if (global._interceptor2 != null) axios.interceptors.response.eject(global._interceptor2);

    global._interceptor1 = axios.interceptors.request.use(
        async request => {
            const jwtToken = await tokenHelper.getToken();
            if (jwtToken != null)
                request.headers.Authorization = 'Bearer ' + jwtToken;

            if (!request.metadata?.ignoreLoading) {
                dispatch({ type: 'SET_LOADING', payload: true });
                requests.current += 1;
            }

            return request;
        }, error => {
            return Promise.reject(error);
        }
    );

    global._interceptor2 = axios.interceptors.response.use(
        response => {
            if (!response.config?.metadata?.ignoreLoading) {
                requests.current -= 1;
                if (requests.current <= 0) {
                    requests.current = 0;
                    dispatch({ type: 'SET_LOADING', payload: false });
                }
            }
            return response;
        },
        error => {
            requests.current -= 1;
            if (requests.current <= 0) {
                requests.current = 0;
                dispatch({ type: 'SET_LOADING', payload: false });
            }

            if (error.status === 401) {
                const isLoginEndpoint = error.config?.url?.includes('/auth/login');
                if (!isLoginEndpoint) {
                    dispatch({ type: 'SET_LOGGED', payload: null });
                    error.message = 'SESSION_EXPIRED';
                }
            }

            return Promise.reject(error);
        }
    );

    return children;
};
